import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button, Form, Dropdown, Offcanvas } from 'react-bootstrap';
import { BsCalendar, BsClock } from 'react-icons/bs';
import { FaStar } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import DoctorAvailability from './DoctorAvailability';
import { MdArrowBack } from "react-icons/md";
import * as apicall from '../../components/Apicall';
import { toast } from 'react-toastify';
import { getRole } from '../../components/Apicall';
import { RiGraduationCapLine } from "react-icons/ri";
import { RiStethoscopeLine } from "react-icons/ri";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import UserContext from '../../components/context/UserContext';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { IoCalendarOutline } from "react-icons/io5";



const DoctorProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [doctorData, setDoctorData] = useState(location.state?.doctorData);
  const servicePrefix = location.state?.serviceNames || '';
  const onProfileUpdate = location.state?.onProfileUpdate;

  const [showEditSidebar, setShowEditSidebar] = useState(false);

  const [isAvailable, setIsAvailable] = useState(true);
  const [showAvailabilityOptions, setShowAvailabilityOptions] = useState(false);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState(null);
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [savedDate, setSavedDate] = useState(null);
  const [savedTime, setSavedTime] = useState(null);
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);
  const [summaryText, setSummaryText] = useState('');
  const [selectedStartTime, setSelectedStartTime] = useState([]);
  const [calendarRange, setCalendarRange] = useState([null, null]);
  const [selectedDate, setSelectedDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [isAppointmentCance, setIsAppointmentCancel] = useState(false)
  const [bookingIds, setBookingIds] = useState([]);
  const [bookingTimes, setBookingTimes] = useState([]);
  const [bookingObject, setBookingObject] = useState([]);
  const [optionSelected, setOptionSelected] = useState("")
  const vendorIdFromStorage = localStorage.getItem("vendorId");
  const [scheduleType, setScheduleType] = useState("")
  const startDate = new Date(calendarRange[0]);
  const endDate = new Date(calendarRange[1]);
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const { vendor } = useContext(UserContext);
  const [serviceId, setServiceId] = useState('');
  const [specializations, setSpecializations] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [feeRange, setFeeRange] = useState({ fee_from: '', fee_to: '' });

  const unavailableDatesObj = unavailableDates.map(dateStr => new Date(dateStr));
  const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const formattedStartDate = formatDateLocal(startDate);
  const formattedEndDate = formatDateLocal(endDate);

  //function to convert date to 12 hours
  const convertTo12Hr = (time24) => {
    const [hour, minute] = time24.split(":");
    const hourNum = parseInt(hour);
    const period = hourNum >= 12 ? "PM" : "AM";
    const hour12 = hourNum % 12 || 12;
    return `${hour12}:${minute} ${period}`;
  };

  useEffect(() => {
    const role = getRole();
    setUserRole(role);
  }, []);

  useEffect(() => {
    if (vendor && vendor.service) {
      setServiceId(vendor.service);
    }
  }, [vendor]);

  useEffect(() => {
    if (vendor) {
      setFeeRange({
        fee_from: vendor.fee_from || '',
        fee_to: vendor.fee_to || ''
      });
    } else {
      setFeeRange({ fee_from: '', fee_to: '' });
    }
  }, [vendor]);

  useEffect(() => {
    if (serviceId) {
      fetchSpecializations();
      fetchEducationOptions();
    }
  }, [serviceId]);

  const fetchSpecializations = async () => {
    try {
      const response = await apicall.get(`get_service_offerings/${serviceId}`);
      if (response.status === 200) {
        setSpecializations(response.data);
      }
    } catch (error) {
      console.error('Error fetching specializations:', error);
    }
  };

  const fetchEducationOptions = async () => {
    try {
      const response = await apicall.get(`serviceProviderEducation/${serviceId}`);
      if (response && response.data) {
        setEducationOptions(response.data);
      }
    } catch (error) {
      console.error('Error fetching education options:', error);
    }
  };

  const selectedTimeStrings = selectedStartTime.map(item => item.timeString);

  const filteredBookedSlots = bookingObject.length !== 0
    ? bookingObject.filter(b =>
      selectedTimeStrings.includes(convertTo12Hr(b.service_time))
    )
    : [];

  let handleBack;
  if (userRole === '3') {
    handleBack = () => navigate('/doctors');
  } else {
    handleBack = () => navigate('/users');
  }
  const handleAvailabilityToggle = () => {
    if (isAvailable) {
      setShowAvailabilityOptions(true);
    }
    setIsAvailable(!isAvailable);
  };

  //function call get dates of the holiday from particular start date to the end date
  const getDatesInRange = (startDate, endDate) => {
    const dates = [];
    const getDatePart = (dateStr) => dateStr.split(' ')[0];
    const start = new Date(`${getDatePart(startDate)}T00:00:00Z`);
    const end = new Date(`${getDatePart(endDate)}T00:00:00Z`);

    const current = new Date(start);

    while (current <= end) {
      // Format as YYYY-MM-DD
      const dateStr = current.toISOString().split('T')[0];
      dates.push(dateStr);
      current.setUTCDate(current.getUTCDate() + 1);
    }

    return dates;
  };



  //function call to call doctors leaves
  const fetchDoctorHolidays = async (doctorId) => {
    try {
      const response = await apicall.get(`get_holidays?user_id=${doctorId}`);

      if (response.status === 200) {
        if (response.data.length > 0) {
          const allUnavailableDates = response.data.flatMap(holiday =>
            getDatesInRange(holiday.holiday_start, holiday.holiday_end)
          );
          const uniqueUnavailableDates = [...new Set(allUnavailableDates)];
          setUnavailableDates(uniqueUnavailableDates);
        } else {
          setUnavailableDates([]);
        }
      } else {
        toast.error('Failed to fetch doctor holidays');
      }
    } catch (error) {
      console.error('Error fetching doctor holidays:', error);
      toast.error('Failed to fetch doctor holidays');
    }
  };


  //function call to call the holiday api 
  const handleHolidayApi = async () => {
    const holidayReqBody = {
      user_id: doctorData?.id,
      holiday_start: formattedStartDate + "T00:00:00",
      holiday_end: formattedEndDate + "T23:59:59",
      created_by: doctorData?.id
    };

    try {
      const holidayRes = await apicall.post(holidayReqBody, 'add_holiday');
      if (holidayRes.status === 200) {
        toast.success('Holiday updated successfully');
      } else {
        toast.error('Failed to update holiday');
      }
    } catch (holidayError) {
      console.error('Error in holiday API:', holidayError);
      toast.error('Failed to update holiday');
    }

  }

  //function  call to handle reschedule the appointment
  const handleRescheduleAppointment = async () => {
    const payload = {
      service_provider: doctorData?.id,
      ...(scheduleType && scheduleType !== "date" && {
        reschedule_type: scheduleType,
      }),
      bookings: filteredBookedSlots,
      ...(scheduleType === "date" && {
        reschedule_type: "range",
        start_date: formattedStartDate,
        end_date: formattedStartDate,
      }),
    };
    try {
      const response = await apicall.post(payload, 'updateMultipleBookings');
      if (response.status === 200) {
        toast.success('Appointments rescheduled successfully');
        setOptionSelected("")
        // handleHolidayApi()
        // Optionally clear any state or UI feedback here
      } else {
        toast.error('Failed to reschedule appointments');
      }
    } catch (error) {
      console.error('Error in Appointment reschedule:', error);
      toast.error('Failed to reschedule appointments');
    }

  };

  //function call to handle Cancel appointment
  const handleCancelAppointment = async () => {
    const payload = {
      service_provider: doctorData?.id,
      status: 14,
      bookings: bookingIds
    };

    try {
      const cancelRes = await apicall.post(payload, 'updateMultipleBookings');
      if (cancelRes.status === 200) {
        toast.success('Appointments cancelled successfully');
        setOptionSelected("")
        setSavedDate(null);
        handleHolidayApi()
      } else {
        toast.error('Failed to cancel appointments');
      }
    } catch (cancelError) {
      console.error('Error in cancelling appointments:', cancelError);
      toast.error('Failed to cancel appointments');
    }

  };

  useEffect(() => {
    if (doctorData) {
      fetchBookingData();
      fetchDoctorHolidays(doctorData?.id)
    }
  }, [calendarRange]);

  //function call to get booking data
  const fetchBookingData = async () => {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_booking_details/range/${formattedStartDate}/${formattedEndDate}/${vendorIdFromStorage}?doctor_id=${doctorData?.id}`
      );

      if (response.status === 200) {
        const filteredResponse = response.data.filter(item => item.status !== 14);

        const bookingsWithDateTime = filteredResponse.map(item => ({
          id: item.id,
          service_time: item.booking_time,
          service_date: item.booking_date,
          no_of_slots: item.no_of_slots,
          original_time: item.booking_time
        }));

        setBookingObject(bookingsWithDateTime);

        // Create time slots with date information
        const timeSlots = filteredResponse.map(item => {
          const [hour, minute] = item.booking_time.split(':');
          const h = parseInt(hour, 10);
          const period = h >= 12 ? 'PM' : 'AM';
          const formattedHour = h % 12 === 0 ? 12 : h % 12;
          return {
            timeString: `${formattedHour}:${minute} ${period}`,
            date: item.booking_date,
            originalTime: item.booking_time,
            id: item.id
          };
        });

        setBookingTimes(timeSlots);
        setBookingIds(filteredResponse.map(item => ({ id: item.id })));
      }
    } catch (error) {
      console.error('Error fetching doctors:', error);
      toast.error('Failed to fetch booking data');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    setShowAvailabilityOptions(true);
    setSelectedDate(savedDate?.toLocaleDateString() || '');
    setSelectedTime(savedTime);
  };

  const handleSelect = () => {
    setShowDateDropdown(!showDateDropdown);
    setShowCalendar(false);
    setShowTimeDropdown(false);
  };

  //fucnction call to set date with out calendar for today and tomorrow
  const handleQuickSelect = (type) => {
    const today = new Date();
    let startDate, endDate;

    if (type === 'today') {
      startDate = new Date(today.setHours(0, 0, 0, 0));
      endDate = new Date(today.setHours(23, 59, 59, 999));
    } else if (type === 'tomorrow') {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      startDate = new Date(tomorrow.setHours(0, 0, 0, 0));
      endDate = new Date(tomorrow.setHours(23, 59, 59, 999));
    }

    setCalendarRange([startDate, endDate]);
    setShowCalendar(false);
    setShowTimeDropdown(true);
    setRescheduleDate(startDate);

    let summary = selectedDate;
    summary += ` | Rescheduled: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
    setSummaryText(summary);
  };

  //function call to select date type today or tomorrow 
  const handleDateSelect = (label) => {
    setSelectedDate(label);
    setShowDateDropdown(false);
    setShowFloatingMenu(true);
    setShowCalendar(false);
    if (label === 'Today') {
      setScheduleType("today")
      handleQuickSelect('today');
      setShowCalendar(false);

    } else if (label === 'Tomorrow') {
      setScheduleType("tomorrow")
      const tomorrow = new Date();
      handleQuickSelect('tomorrow');
      tomorrow.setDate(tomorrow.getDate() + 1);
      setShowCalendar(false);

    } else {
      setScheduleType("date")
      setShowCalendar(true);
    }
  };

  //function call to handle schedule date dropdown
  const handleRescheduleSelect = (action) => {
    setShowFloatingMenu(false);
    if (action === 'reschedule') {
      setOptionSelected('reschedule')
      if (scheduleType === "today" || scheduleType === "tomorrow") {
        setShowCalendar(false);
      } else {
        setShowCalendar(true);
      }
    } else {
      if (scheduleType === "today" || scheduleType === "tomorrow") {
        setShowCalendar(false);
      } else {
        setShowCalendar(true);
      }
      setOptionSelected('cancel')
      setShowFloatingMenu(false);
      setIsAppointmentCancel(true)
    }

    setShowTimeDropdown(false);
  };

  //function call to select date range from calendar
  const handleCalendarRangeSelect = (dates) => {
    const [start, end] = dates;
    setCalendarRange([start, end]);
    if (start && end) {
      setShowCalendar(false);
      setShowTimeDropdown(true);
      setRescheduleDate(start);
      let summary = selectedDate;
      summary += ` | Rescheduled: ${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
      setSummaryText(summary);
    }
  };

  //function call to select the slot time
  const handleTimeSelect = (slot) => {
    setSelectedStartTime((prevSelected) => {
      const selected = Array.isArray(prevSelected) ? [...prevSelected] : [];
      const existingIndex = selected.findIndex(s => s.id === slot.id);

      if (existingIndex > -1) {
        selected.splice(existingIndex, 1);
      } else {
        selected.push(slot);
      }

      return selected;
    });
  };



  //function call on click of save
  const handleSave = async () => {
    setShowAvailabilityOptions(false);
    setShowDateDropdown(false);
    setShowCalendar(false);
    setShowTimeDropdown(false);
    setIsEditing(false);

    try {
      if (isAppointmentCance && optionSelected === 'cancel') {
        if (bookingTimes.length !== 0) {
          await handleCancelAppointment();
        }
        await handleHolidayApi();
      }

      if (optionSelected === 'reschedule') {
        await handleHolidayApi();
        if (bookingTimes.length !== 0) {
          await handleRescheduleAppointment();
        }
      }

    } catch (error) {
      console.error('Error in handleSave:', error);
      toast.error('Failed to complete the operation');
    }
  };

  //function call on click of cancel
  const handleCancel = () => {
    setShowAvailabilityOptions(false);
    setIsAvailable(true);
    setSavedDate(null);
    setShowDateDropdown(false);
    setShowCalendar(false);
    setShowTimeDropdown(false);
    setSelectedDate('');
    setSummaryText('')
    setBookingTimes([])
    setSelectedStartTime([]);
    setRescheduleDate(null);
    setSelectedTime(null);
    setIsEditing(false);
  };

  const CustomDropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Button
      ref={ref}
      variant="outline-secondary"
      size="sm"
      className="d-flex align-items-center gap-1"
      onClick={onClick}
      style={{ fontSize: '14px', height: '32px', borderRadius: '4px' }}
    >

      {children || 'Select'}
      {children === 'Select Time' ? <BsClock /> : <BsCalendar />}
    </Button>
  ));

  const dateOptions = ['Today', 'Tomorrow', 'Select Date'];

  const EditProfileSidebar = ({ userRole, navigate }) => {
    const currentSpecializationId = doctorData?.specialization_id || doctorData?.specilisation || '';

    const [educationValue, setEducationValue] = useState('');

    const initialValues = {
      fullName: doctorData?.first_name
        ? `${doctorData.first_name || ''} ${doctorData.last_name || ''}`.trim()
        : `${doctorData?.name || ''} ${doctorData?.last_name || ''}`.trim(),
      gender: doctorData?.gender === 1 || doctorData?.gender === '1' || doctorData?.gender === 'Male'
        ? '1'
        : doctorData?.gender === 2 || doctorData?.gender === '2' || doctorData?.gender === 'Female'
          ? '2'
          : '',
      specialization: currentSpecializationId,
      education: educationValue,
      date_of_birth: doctorData?.dob || doctorData?.date_of_birth || '',
      experience_start_date: doctorData?.practice_start || '',
      about: doctorData?.about_user || '',
      consultation_fees: doctorData?.fee || '',
      phone_number: doctorData?.phone_number || doctorData?.phone || '',
      email: doctorData?.email || ''
    };

    useEffect(() => {
      if (doctorData?.education) {

        // If education is already an ID (numeric)
        if (!isNaN(doctorData.education)) {
          setEducationValue(doctorData.education);
        } else if (educationOptions.length > 0) {
          const edu = educationOptions.find(e => e.degree_name === doctorData.education);
          if (edu) {
            setEducationValue(edu.id);
          } else {
            // If not found, set the name as fallback
            console.log('No education match found, using name as fallback');
            setEducationValue(doctorData.education);
          }
        } else {
          setEducationValue(doctorData.education);
        }
      }
    }, [educationOptions, doctorData?.education]);

    const validationSchema = Yup.object({
      fullName: Yup.string()
        .required('Doctor name is required')
        .min(2, 'Doctor name must be at least 2 characters')
        .max(40, 'Doctor name cannot exceed 40 characters'),
      gender: Yup.string().oneOf(['1', '2'], 'Please select a valid gender').required('Gender is required'),
      specialization: Yup.string()
        .required('Specialization is required'),
      education: Yup.string()
        .required('Education is required'),
      date_of_birth: Yup.date()
        .required('Date of birth is required')
        .max(new Date(new Date().setFullYear(new Date().getFullYear() - 15) - 24 * 60 * 60 * 1000), 'Doctor must be at least 15 years old')
        .min(new Date(1900, 0, 1), 'Invalid date of birth'),
      experience_start_date: Yup.date()
        .required('Experience start date is required')
        .max(new Date(Date.now() - 24 * 60 * 60 * 1000), 'Experience start date cannot be in the future')
        .test('after-dob', 'Experience start date must be after date of birth', function (value) {
          const { date_of_birth } = this.parent;
          if (!date_of_birth || !value) return true;
          return new Date(value) > new Date(date_of_birth);
        }),

      consultation_fees: Yup.number()
        .required('Consultation fees is required')
        .positive('Consultation fees must be positive')
        .max(10000, 'Consultation fees cannot exceed 10,000')
        .test(
          'fee-range',
          `Fee must be between AED ${feeRange.fee_from} and AED ${feeRange.fee_to}`,
          function (value) {
            if (!feeRange.fee_from || !feeRange.fee_to) return true;
            const fee = Number(value);
            const from = Number(feeRange.fee_from);
            const to = Number(feeRange.fee_to);
            return fee >= from && fee <= to;
          }
        ),
      email: Yup.string()
        .email('Invalid email format')
        .required('Email is required')
        .max(100, 'Email must not exceed 100 characters')
        .test('email-format', 'Please enter a valid email address', function (value) {
          if (!value) return true;
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emailRegex.test(value);
        }),
      about: Yup.string()
        .required('About section is required')
        .min(10, 'About section must be at least 10 characters')
        .max(500, 'About section cannot exceed 500 characters'),
      phone_number: Yup.string()
        .required('Phone number is required')
      // .matches(/^[0-9]+$/, 'Phone number must contain only digits')
      // .min(9, 'Phone number must be at least 9 digits')
      // .max(15, 'Phone number must not exceed 15 digits')
    });

    const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
      try {
        // Additional client-side validation
        if (!values.fullName.trim()) {
          setFieldError('fullName', 'Doctor name cannot be empty');
          return;
        }

        const [firstName, ...lastNameParts] = values.fullName.trim().split(' ');
        const lastName = lastNameParts.join(' ');

        const payload = {
          user_id: doctorData.id,
          first_name: firstName,
          last_name: lastName,
          gender: Number(values.gender),
          phone_number: values.phone_number,
          country_id: 0,
          state_id: 0,
          city_id: 0,
          dob: new Date(values.date_of_birth).toISOString().split('T')[0],
          practice_start: new Date(values.experience_start_date).toISOString().split('T')[0],
          about_user: values.about?.trim() || '',
          fee: values.consultation_fees,
          specilisation: values.specialization,
          is_active: 1,
          education: values.education
        };

        if (values.email !== doctorData.email) {
          payload.email = values.email.trim();
        }

        const response = await apicall.post(payload, 'updateUser');
        if (response.status === 200) {
          toast.success('Profile updated successfully');
          
          // Fetch the latest doctor data
          const updatedDoctor = await fetchDoctorById(doctorData.id);
          if (updatedDoctor) {
            setDoctorData(updatedDoctor);
          }
          setShowEditSidebar(false);
          window.location.reload();
        } else {
          toast.error(response.message || 'Failed to update profile');
        }
      } catch (error) {
        console.error('Error updating profile:', error);
        if (error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error('Failed to update profile. Please try again.');
        }
      } finally {
        setSubmitting(false);
      }
    };

    return (
      <Offcanvas
        show={showEditSidebar}
        onHide={() => setShowEditSidebar(false)}
        placement="end"
        style={{ width: '500px' }}
      >
        <Offcanvas.Header closeButton className="custom-border-bottom p-4">
          <Offcanvas.Title className="page-heading">Edit Profile</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="p-4">
            <Formik
              initialValues={{
                ...initialValues,
                education: educationValue
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
              key={educationValue}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                setFieldTouched,
                submitForm
              }) => (
                <>
                  <Form onSubmit={handleSubmit} id="edit-profile-form">
                    <div className="mb-4">
                      <h6 className="profile-section-heading mb-3">Personal Details</h6>
                      <Form.Group className="mb-3">
                        <Form.Label >Doctor Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="fullName"
                          value={values.fullName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${touched.fullName && errors.fullName ? 'is-invalid' : ''}`}
                          placeholder="Enter doctor name"
                        />
                        {touched.fullName && errors.fullName && (
                          <div className="invalid-feedback d-block">{errors.fullName}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label >Gender</Form.Label>
                        <Form.Select
                          name="gender"
                          value={values.gender}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${touched.gender && errors.gender ? 'is-invalid' : ''}`}
                        >
                          <option value="">Choose Gender</option>
                          <option value="1">Male</option>
                          <option value="2">Female</option>
                        </Form.Select>
                        {touched.gender && errors.gender && (
                          <div className="invalid-feedback d-block">{errors.gender}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label >Specialization</Form.Label>
                        <Form.Select
                          name="specialization"
                          value={values.specialization}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={` ${touched.specialization && errors.specialization ? 'is-invalid' : ''}`}
                          style={{ fontSize: '14px' }}
                        >
                          <option value="">Select Specialization</option>
                          {specializations.map((spec) => (
                            <option key={spec.id} value={spec.id}>{spec.name}</option>
                          ))}
                        </Form.Select>
                        {touched.specialization && errors.specialization && (
                          <div className="invalid-feedback d-block">{errors.specialization}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label >Education</Form.Label>
                        <Form.Select
                          name="education"
                          value={values.education}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${touched.education && errors.education ? 'is-invalid' : ''}`}
                          disabled={educationOptions.length === 0}
                        >
                          <option value="">
                            {educationOptions.length === 0 ? 'Loading...' : 'Select Education'}
                          </option>
                          {educationOptions.map((edu) => (
                            <option key={edu.id} value={edu.id}>{edu.degree_name}</option>
                          ))}
                        </Form.Select>
                        {touched.education && errors.education && (
                          <div className="invalid-feedback d-block">{errors.education}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Date of Birth</Form.Label>
                        <div className="position-relative">
                          <DatePicker
                            selected={values.date_of_birth ? new Date(values.date_of_birth) : null}
                            onChange={(date) => setFieldValue('date_of_birth', date)}
                            onBlur={handleBlur}
                            dateFormat="yyyy-MM-dd"
                            className={`form-control form-input ${touched.date_of_birth && errors.date_of_birth ? 'is-invalid' : ''}`}
                            maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 15) - 24 * 60 * 60 * 1000)}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select Date"
                          />
                          <IoCalendarOutline
                            className="position-absolute end- top-50 translate-middle-y pe-none"
                            style={{
                              right: errors.date_of_birth && touched.date_of_birth ? '1.75rem' : '0.75rem',
                            }}
                          />
                        </div>
                        {touched.date_of_birth && errors.date_of_birth && (
                          <div className="invalid-feedback d-block">{errors.date_of_birth}</div>
                        )}
                      </Form.Group>


                      <Form.Group className="mb-3">
                        <Form.Label>Experience Started On</Form.Label>
                        <div className="position-relative">
                          <DatePicker
                            selected={values.experience_start_date ? new Date(values.experience_start_date) : null}
                            onChange={(date) => setFieldValue('experience_start_date', date)}
                            onBlur={handleBlur}
                            dateFormat="yyyy-MM-dd"
                            maxDate={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                            className={`form-control form-input ${touched.experience_start_date && errors.experience_start_date ? 'is-invalid' : ''}`}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select Date"
                          />
                          <IoCalendarOutline
                            className="position-absolute end-1 top-50 translate-middle-y pe-none"
                            style={{
                              right: errors.experience_start_date && touched.experience_start_date ? '1.75rem' : '0.75rem',
                            }}
                          />
                        </div>
                        {touched.experience_start_date && errors.experience_start_date && (
                          <div className="invalid-feedback d-block">{errors.experience_start_date}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label >About You</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="about"
                          rows={3}
                          value={values.about}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${touched.about && errors.about ? 'is-invalid' : ''}`}
                          placeholder="Tell us about yourself..."
                        />
                        {touched.about && errors.about && (
                          <div className="invalid-feedback d-block">{errors.about}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label >Consultation Fees</Form.Label>
                        <Form.Control
                          type="number"
                          name="consultation_fees"
                          value={values.consultation_fees}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${touched.consultation_fees && errors.consultation_fees ? 'is-invalid' : ''}`}
                          placeholder="Enter consultation fees"
                          min="0"
                          max="10000"
                        />
                        {feeRange.fee_from && feeRange.fee_to && (
                          <small className="text-muted">
                            Range: AED {feeRange.fee_from} - {feeRange.fee_to}
                          </small>
                        )}
                        {touched.consultation_fees && errors.consultation_fees && (
                          <div className="invalid-feedback d-block">{errors.consultation_fees}</div>
                        )}
                      </Form.Group>
                    </div>

                    <div className="mb-4">
                      <h6 className="profile-section-heading mb-3">Contact Details</h6>
                      <Form.Group className="mb-3">
                        <Form.Label >Phone Number</Form.Label>
                        <PhoneInput
                          country={'ae'}
                          onlyCountries={['ae', 'in']}
                          value={values.phone_number}
                          onChange={(value) => {
                            const cleanedValue = value.replace(/\D/g, '');
                            setFieldValue('phone_number', cleanedValue);
                          }}
                          onBlur={() => setFieldTouched('phone_number', true)}
                          inputStyle={{
                            width: '100%',
                            height: '40px',
                            backgroundColor: '#F8F9FA',
                            borderColor: touched.phone_number && errors.phone_number ? '#dc3545' : '#E9ECEF'
                          }}
                          inputProps={{
                            name: 'phone_number',
                            required: true,
                            disabled: true
                          }}
                          disabled={true}
                        />
                        {touched.phone_number && errors.phone_number && (
                          <div className="invalid-feedback d-block">{errors.phone_number}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label >Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${touched.email && errors.email ? 'is-invalid' : ''}`}
                          placeholder="Enter email address"
                        />
                        {touched.email && errors.email && (
                          <div className="invalid-feedback d-block">{errors.email}</div>
                        )}
                      </Form.Group>
                    </div>
                  </Form>
                  <div className="custom-border-top p-4" style={{
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'white',
                    display: 'flex',
                    gap: '12px'
                  }}>
                    <Button
                      variant="light"
                      onClick={() => setShowEditSidebar(false)}
                      className="custom-radius btn-outline-borders"
                      style={{ flex: 1 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-custom-danger custom-radius"
                      style={{ flex: 1 }}
                      onClick={submitForm}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Saving...' : 'Save Changes'}
                    </Button>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    );
  };

  const getRandomColor = () => {
    const colors = [
      '#FFE4E1',
      '#E6E6FA',
      '#F0FFF0',
      '#F0F8FF',
      '#FFF0F5',
      '#F5F5DC',
      '#E0FFFF',
      '#FFE4B5',
      '#F0FFFF',
      '#F8F8FF'
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : 'D';
  };

  const fetchDoctorById = async (doctorId) => {
    const response = await apicall.get(`get_service_providers?user_id=${doctorId}`);
    if (response && response.status === 200 && Array.isArray(response.data)) {
      const doc = response.data[0];
      if (!doc) return null;
      // Normalize gender for UI
      let genderValue = '2';
      if (doc.gender === 1 || doc.gender === '1' || doc.gender === 'Male') genderValue = '1';
      if (doc.gender === 2 || doc.gender === '2' || doc.gender === 'Female') genderValue = '2';
      return {
        ...doc,
        gender: genderValue,
        name: `${doc.first_name || ''} ${doc.last_name || ''}`.trim(),
        specialization: doc.specilisation_name || doc.specialization,
        specialization_id: doc.specilisation_id || doc.specilisation,
        rating: doc.average_rating ?? 0,
        experience: doc.practice_start ? `${new Date().getFullYear() - new Date(doc.practice_start).getFullYear()} Years Experience` : '',
        reviews: doc.total_bookings ?? 0,
      };
    }
    return null;
  };

  return (
    <div style={{ backgroundColor: '#F2F5FA', minHeight: '100vh', padding: '24px' }}>
      <button onClick={handleBack} className="d-flex align-items-center border-0 bg-transparent mb-3" style={{ fontSize: '14px', color: '#212529', padding: 0 }}>
        <MdArrowBack size={20} /> BACK
      </button>

      <div className="bg-white rounded-3 p-4 mb-4">
        <div className="d-flex gap-4">
          {doctorData.profile_image ? (
            <img
              src={doctorData.profile_image}
              alt={doctorData.name}
              style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', cursor: 'pointer' }}
              onClick={() => setShowEditSidebar(true)}
              onError={(e) => {
                const div = document.createElement('div');
                div.style.width = '80px';
                div.style.height = '80px';
                div.style.borderRadius = '50%';
                div.style.backgroundColor = getRandomColor();
                div.style.display = 'flex';
                div.style.alignItems = 'center';
                div.style.justifyContent = 'center';
                div.style.fontSize = '32px';
                div.style.color = '#666666';
                div.style.fontWeight = 'bold';
                div.style.cursor = 'pointer';
                div.textContent = getInitials(doctorData.name);
                div.onclick = () => setShowEditSidebar(true);
                e.target.parentNode.replaceChild(div, e.target);
              }}
            />
          ) : (
            <div
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: getRandomColor(),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px',
                color: '#666666',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
              onClick={() => setShowEditSidebar(true)}
            >
              {getInitials(doctorData.name)}
            </div>
          )}

          <div className="flex-grow-1">
            <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '4px' }}>
              {(servicePrefix || doctorData.serviceShortName)
                ? `${servicePrefix || doctorData.serviceShortName}. `
                : ''}
              {doctorData.name?.charAt(0).toUpperCase() + doctorData.name?.slice(1)}
            </h4>
            <p style={{ fontSize: '14px', color: '#6C757D', marginBottom: '8px' }}>
              {(doctorData.specialty || doctorData.specialization)?.charAt(0).toUpperCase() +
                (doctorData.specialty || doctorData.specialization)?.slice(1)}
            </p>

            <div className="d-flex align-items-center gap-4" style={{ fontSize: '14px', color: '#6C757D' }}>
              {/* Experience */}
              {doctorData.experience && (
                <div className="d-flex align-items-center gap-2">
                  <RiStethoscopeLine className="fs-5" />
                  <span>
                    {(() => {
                      const exp = doctorData.experience.trim();
                      if (/experience/i.test(exp)) {
                        return exp.replace(/(experience\s*){2,}/gi, 'Experience');
                      } else {
                        return `${exp} Experience`;
                      }
                    })()}
                  </span>
                </div>
              )}


              {/* Education */}
              <div className="d-flex align-items-center gap-2">
                <RiGraduationCapLine className="fs-5" />
                <span>{doctorData.education}</span>
              </div>

              {/* Rating and Edit Button */}
              <div className="d-flex align-items-center gap-2">
                <span className="d-flex align-items-center gap-1">
                  <FaStar className="text-warning" />
                  {doctorData.rating} ({doctorData.reviews} reviews)
                </span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setShowEditSidebar(true)}
                  style={{
                    fontSize: '12px',
                    padding: '2px 8px',
                    height: 'auto',
                    borderRadius: '4px',
                    marginLeft: '8px'
                  }}
                >
                  Edit profile
                </Button>
              </div>
            </div>


            <div className="d-flex align-items-center gap-2 mt-2">
              <span style={{ fontSize: '12px', fontWeight: '600' }}>
                {isAvailable ? 'Available' : 'Not Available'}
              </span>
              <Form.Check type="switch" id="availability-switch" checked={isAvailable} onChange={handleAvailabilityToggle} />
              {!isAvailable && !showAvailabilityOptions && savedDate && savedTime && (
                <div className="d-flex align-items-center gap-2 ms-3">
                  <span style={{ fontSize: '14px', color: '#6C757D' }}>Today, {savedTime}</span>
                  <span style={{ fontSize: '14px', color: '#6C757D' }}>
                    | Rescheduled: {savedDate.toLocaleDateString()} To {savedDate.toLocaleDateString()}
                  </span>
                  <Button variant="outline-secondary" size="sm" onClick={handleEdit} style={{ fontSize: '14px', height: '32px', borderRadius: '4px', color: '#C9194A', borderColor: '#C9194A' }}>
                    Edit
                  </Button>
                </div>
              )}
              {!isAvailable && showAvailabilityOptions && (
                <div className="d-flex align-items-center gap-2 ms-3 position-relative">
                  <Dropdown show={showDateDropdown} onToggle={handleSelect}>
                    <Dropdown.Toggle as={CustomDropdownToggle}>
                      {summaryText || (selectedDate instanceof Date ? selectedDate.toDateString() : selectedDate) || 'Select'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ minWidth: '150px' }}>
                      {dateOptions.map((option) => (
                        <Dropdown.Item key={option} onClick={() => handleDateSelect(option)}>
                          {option}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>

                  {showFloatingMenu && !showCalendar && (
                    <div style={{ position: 'relative' }}>
                      <div className="bg-white shadow rounded-3" style={{ position: 'absolute', left: '110%', top: '20px', minWidth: '150px', zIndex: 1000 }}>
                        <div className="dropdown-item" style={{ cursor: 'pointer', padding: '8px 16px', fontWeight: 500, background: '#FFF0F4' }} onClick={() => handleRescheduleSelect('reschedule')}>
                          Reschedule
                        </div>
                        <div className="dropdown-item" style={{ cursor: 'pointer', padding: '8px 16px' }} onClick={() => handleRescheduleSelect('cancel')}>
                          Cancel Appointment
                        </div>
                      </div>
                    </div>
                  )}

                  {showCalendar && (
                    <div className="position-absolute bg-white shadow-lg rounded-3 p-2" style={{ top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: '8px', zIndex: 1000 }}>
                      <DatePicker
                        selectsRange
                        startDate={calendarRange[0]}
                        endDate={calendarRange[1]}
                        onChange={handleCalendarRangeSelect}
                        inline
                        minDate={new Date()}
                        excludeDates={unavailableDatesObj}
                        highlightDates={[
                          {
                            'react-datepicker__day--highlighted-holiday': unavailableDatesObj,
                          },]}
                      />
                    </div>
                  )}

                  {!showCalendar && (
                    <Dropdown show={showTimeDropdown} onToggle={() => setShowTimeDropdown(!showTimeDropdown)}>
                      <Dropdown.Toggle as={CustomDropdownToggle}>
                        {selectedStartTime.length > 0
                          ? selectedStartTime.map(item => item.timeString).join(', ')
                          : 'Select Time'}
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="p-2 border rounded shadow" style={{ maxHeight: '300px', overflowY: 'auto', minWidth: '150px' }}>
                        <div className="px-2 py-1 text-muted small fw-semibold border-bottom mb-2">
                          Select Time
                        </div>
                        {bookingTimes.length > 0 && (
                          <div className="px-3 py-2 border-bottom">
                            <Form.Check
                              type="checkbox"
                              id="select-all-slots"
                              label="Select All"
                              checked={selectedStartTime.length === bookingTimes.length}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedStartTime([...bookingTimes]);
                                } else {
                                  setSelectedStartTime([]);
                                }
                              }}
                            />
                          </div>
                        )}

                        {bookingTimes.map((slot) => (
                          <Dropdown.Item
                            key={`${slot.date}-${slot.originalTime}`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleTimeSelect(slot);
                            }}
                            className={`px-3 py-2 rounded ${selectedStartTime.some(
                              selected => selected.id === slot.id
                            ) ? 'bg-primary bg-opacity-10 text-primary' : ''}`}
                          >
                            <div>
                              <div>{slot.timeString}</div>
                              <div className="small text-muted">{new Date(slot.date).toLocaleDateString()}</div>
                            </div>
                          </Dropdown.Item>
                        ))}
                        {
                          bookingTimes.length === 0 && (
                            <div className="px-3 py-2 text-muted small">
                              No available slots
                            </div>
                          )
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  )}

                  <Button variant="danger" size="sm" onClick={handleSave} style={{ fontSize: '14px', height: '32px', borderRadius: '4px', backgroundColor: '#C9194A' }}>
                    Save
                  </Button>
                  <Button variant="link" size="sm" onClick={handleCancel} style={{ fontSize: '14px', color: '#6C757D', textDecoration: 'none' }}>
                    Cancel
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <DoctorAvailability doctorId={doctorData.id} showBackButton={false} />
      <EditProfileSidebar userRole={userRole} navigate={navigate} />
    </div>
  );
};

export default DoctorProfile; 